import {gql} from '@apollo/client'

export const HEALTHCARE_STATUS = gql`
  query healthcareStatus {
    healthcareStatus
  }
`

export interface HealthcareStatusQueryResult {
  healthcareStatus: HealthcareStatus
}

type HealthcareStatus = 'NOT_STARTED' | 'NO_ADMIN' | 'HAS_ADMIN'
